import React from 'react'

import { observer } from 'mobx-react-lite'
import { useMediaQuery } from '@mui/material'

import { useConfig } from '@/config'
import { useRootStore } from '@/stores/root/store'
import { useResultsControl } from '@/ui/search/results/results-control'

import DesktopSearch from '@/ui/search/DesktopSearch'
import MobileSearch from '@/ui/search/MobileSearch'

import SearchRouteHandler from '@/ui/router/SearchRouteHandler'

const ResultsControlUpdater = observer(() => {
  const store = useRootStore()

  const { setSelectedResult } = useResultsControl({
    subscriber: { searchId: 'all', control: 'searchRoot' },
  })

  React.useEffect(() => {
    setSelectedResult()
  }, [store.search.searchCount])

  return null
})

const Search = () => {
  const { tenantConfig: tc } = useConfig()
  const isSearchRouteHandlerEnabled =
    tc?.routeOptions?.searchRouteHandler?.enabled
  // console.log({ isSearchRouteHandlerEnabled })

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('ph'))
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('ph'))

  return (
    <>
      <ResultsControlUpdater />
      {isSearchRouteHandlerEnabled && <SearchRouteHandler />}

      {isMobile && <MobileSearch />}
      {isDesktop && <DesktopSearch />}
    </>
  )
}

export default Search
